// æ: \u00e6    ø: \u00f8   å: \u00e5

let ErrorDanish = {
    "GeneralError" : "Det opstod en fejl. Pr\u00f8v venligst igen.",
    "DbConxError" : "En fejl opstod ved forbindelsen til databasen. Pr\u00f8v venligst igen.",
    "DbInvalidRequestError" : "Ikke-gyldig data blev sendt.",
    "DbFetchDataError" : "Der opstod en fejl ved hentning af data. Pr\u00f8v venligst igen.",
    "DbGeneralWriteError" : "Der opstod en fejl ved skrivning af data. Venligst pr\u00f8v igen.",
    "DbWriteValuesError" : "Der opstod en fejl ved skrivning af data. Tjek venligst felterne og pr\u00f8v igen.",
    "ConcurrencyException" : "Der opstod en fejl ved opdatering af dine data. Pr\u00f8v venligst igen.",
    "Unauthorized" : "Handling ikke tilladt. Venligst log ind.",
    "Forbidden" : "Handling ikke tilladt.",
    "IdNotAvailable" : "ID er ikke tilg\u00e6ngeligt.",
    "UploadListConxError" : "Der opstod en fejl. Venligst kontakt vores support.",
    
    "UnknownUser" : "Bruger blev ikke fundet.",
    "NoConsents" : "Der er ikke nogle samtykker at vise.",
    "DbCodeCheckError" : "Der opstod en fejl med tjek af koden. Pr\u00f8v venligst igen.",
    "MobileOrEmailInvalid" : "Mobilnummer / e-mailadresse er ikke gyldig.",
    "NoDbMatchForMobileOrEmail" : "Indsendt Mobilnummer / e-mailadresse blev ikke genkendt. Pr\u00f8v venligst igen.",
    "TooManyRecentAttempts" : "For mange foresp\u00f8rgsler (5) indenfor de sidste 24 timer. Vent venligst en dag og pr\u00f8v igen.",
    "RevokeLinkExpiredOrProcessed" : "Link er ikke l\u00e6ngere gyldigt, men du kan klikke her for at logge ind p\u00e5 anden m\u00e5de:",
    "NoConsentsRevoked" : "Der er ikke fundet nogle aktive samtykker.",
    "NoConsentsOnOwnerLogin":"Der blev ikke fundet samtykker for ",
    "NoConsentsInputQuestion": "Er der fejl i det indtastede? Hvis ikke, har vi ikke samtykker registreret på ",

    "NoAccesses" : "Der er ikke oprettet tilladelser. Venligst kontakt Mitsamtykke.",

    "CodeIncorrect" : "Den indtastede kode er ikke korrekt.",
    "CodeRemainingAttempts" : "Tilbagev\u00e6rende fors\u00f8g: ",
    "CodeTimeExpired" : "Din kode er udl\u00f8vbet. Pr\u00f8v venligst igen.",
    "CodeNoMoreAttempts" : "Du har opbrugt dine fors\u00f8g. Pr\u00f8v venligst igen.",
    "DbRevokeError" : "Der opstod en fejl ved afmelding af data. Pr\u00f8v venligst igen.",

    "LoginUserAndPwdEmpty" : "Brugernavn og password skal indgives.",
    "LoginInvalidPwd" : "Ugyldigt password.",
    "LoginNoMoreAttempts" : "Antal fors\u00f8g er overskredet. Kontakt support.",
    "LoginUserNotActive" : "Bruger er ikke aktiv. Kontakt support.",

    "PwdChangeFieldEmpty" : "Alle felter skal indtastes.",
    "PwdChangeConfMismatch" : "Det nye password matcher ikke bekr\u00e6ftelse.",
    "CurAndNewPwdMatch" : "Det nye password er det samme som det nuv\u00e6rende. Ingen \u00e6ndring n\u00f8dvendig.",

    "NoStakeholders" : "Der blev ikke fundet virksomheder.",

    "SearchStringInvalid" : "Indtast navn (min. 3 tegn) eller ID.",
    "NoUsers" : "Der blev ikke fundet brugere.",
    "ResetLoginAttemptsFail": "Kunne ikke lave reset p\u00e5 loginfors\u00f8g. Pr\u00f8v venligst igen.",

    "UserNotFound" : "Bruger findes ikke i databasen.",
    "UserTypeInvalid" : "Brugertype er ikke gyldig.",
    "ModifierUnauthorised" : "Du har ikke rettigheder p\u00e5 dette niveau.",
    "AdvertiserInvalid" : "Advertiser er ikke gyldig.",
    "LoginNameExists" : "Brugernavn eksisterer allerede. V\u00e6lg venligst et andet.",

    "TypeExists" : "Type eksisterer allerede. V\u00e6lg venligst en anden v\u00e6rdi.",

    "ApiKeyExists" : "Api Key eksisterer allerede. V\u00e6lg venligst en anden v\u00e6rdi.",
    "AccessNameExists" : "Accessnavn eksisterer allerede. V\u00e6lg venligst en anden v\u00e6rdi.",

    "NoLogsFound" : "Der blev ikke fundet nogle loglinjer.",

    "FetchFailedRowsDoc" : "Hentning af fejlliste gik galt. Venligst hent manuelt fra listen",

    "DocNotFound": "Document kunne ikke findes.",

    "FileUploaded" : "Fil er gemt.",

    "NoContractsFound" : "Der blev ikke fundet nogle kontraktinfo linjer.",
    "SubscriptionTypeInvalid" : "Kontrakttype er ikke gyldig",
    "StakeholderNameExists" : "Virksomhedsnavn eksisterer allerede. V\u00e6lg venligst et andet.",
    "SignDateTypeInvalid" : "Signatur dato er ikke gyldig",

    "NoExternRefesh" : "Kunne ikke opdaterer fra eksterne advertisers."
}

export { ErrorDanish };
